var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContactsInside',{attrs:{"iW":_vm.iW,"value":_vm.valueContacts,"formFileds":_vm.formFileds,"settings1":_vm.settings1,"bodySettings1":_vm.bodySettings1,"phoneandmail":_vm.phoneandmail,"contactSocials":_vm.contactSocials}})}
var staticRenderFns = []

export { render, staticRenderFns }